// extracted by mini-css-extract-plugin
module.exports = {"children":"layout_children__1M3oK","title":"layout_title__2WxcP"};